import React from 'react';
import { BrainIcon, ActivityIcon, EyeIcon, ShieldIcon, ClockIcon, UsersIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { GlassCard } from '../ui/GlassCard';
const dimensions = [{
  icon: BrainIcon,
  title: 'Consequential Thinking',
  description: 'The ability to think past impulse and weigh long-term outcomes',
  score: 88
}, {
  icon: ActivityIcon,
  title: 'Emotional Regulation',
  description: 'Composure, stability, and control under pressure',
  score: 92
}, {
  icon: EyeIcon,
  title: 'Reality Testing',
  description: 'The capacity to distinguish truth from distortion and maintain contact with evidence',
  score: 76
}, {
  icon: ShieldIcon,
  title: 'Manipulation Resistance',
  description: 'Resilience against propaganda, capture, and emotional hijacking',
  score: 84
}, {
  icon: ClockIcon,
  title: 'Long-Term Decision-Making',
  description: 'The ability to think strategically across time and systems',
  score: 95
}, {
  icon: UsersIcon,
  title: 'Civic Responsibility',
  description: 'The ability to align personal conduct with broader social stability',
  score: 81
}];
export function NCJIFramework() {
  return <SectionWrapper hasDivider glowPosition="center" data-id="element-127">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-128">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 mb-6" data-id="element-129">
          <span className="text-xs font-mono text-blue-300 uppercase tracking-widest" data-id="element-130">
            Core Framework
          </span>
        </div>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6" data-id="element-131">
          The Neurocognitive Civic Judgment Index
        </h2>
        <p className="text-lg text-slate-400 leading-relaxed" data-id="element-132">
          At the center of the model is the Neurocognitive Civic Judgment Index
          (NCJI), a framework for assessing the qualities most essential to
          civic responsibility, leadership, and long-term institutional trust.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-133">
        {dimensions.map((dim, idx) => <GlassCard key={idx} glowColor="cyan" className="relative overflow-hidden group" data-id="element-134">
            {/* Subtle background gradient on hover */}
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-135" />

            <div className="relative z-10 flex items-start justify-between mb-6" data-id="element-136">
              <div className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center" data-id="element-137">
                <dim.icon className="w-5 h-5 text-cyan-400" data-id="element-138" />
              </div>

              {/* Mini Score Ring */}
              <div className="relative w-10 h-10 flex items-center justify-center" data-id="element-139">
                <svg className="absolute inset-0 w-full h-full -rotate-90" viewBox="0 0 36 36" data-id="element-140">
                  <circle cx="18" cy="18" r="16" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="2" data-id="element-141" />
                  <circle cx="18" cy="18" r="16" fill="none" stroke="#22d3ee" strokeWidth="2" strokeDasharray="100" strokeDashoffset={100 - dim.score} className="opacity-50 group-hover:opacity-100 transition-opacity duration-500" data-id="element-142" />
                </svg>
                <span className="text-[10px] font-mono text-cyan-400" data-id="element-143">
                  {dim.score}
                </span>
              </div>
            </div>

            <div className="relative z-10" data-id="element-144">
              <h3 className="text-lg font-semibold text-white mb-2" data-id="element-145">
                {dim.title}
              </h3>
              <p className="text-sm text-slate-400 leading-relaxed" data-id="element-146">
                {dim.description}
              </p>
            </div>
          </GlassCard>)}
      </div>
    </SectionWrapper>;
}